import React, { useState, useEffect } from 'react';
import { subscribeToReplies } from '../services/replyService';
import Reply from './Reply';
import './ReplyList.css';

const ReplyList = ({ postId, currentUser }) => {
  const [replies, setReplies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    setError('');

    const unsubscribe = subscribeToReplies(postId, (repliesData) => {
      setReplies(repliesData);
      setLoading(false);
    });

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [postId]);

  if (loading) {
    return (
      <div className="reply-list-container">
        <div className="loading-replies">
          <div className="loading-spinner-small"></div>
          <p>Loading replies...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="reply-list-container">
        <div className="reply-error-message">
          {error}
        </div>
      </div>
    );
  }

  if (replies.length === 0) {
    return null; // Don't show anything if no replies
  }

  return (
    <div className="reply-list-container">
      <div className="replies-list">
        {replies.map((reply) => (
          <Reply 
            key={reply.id} 
            reply={reply} 
            postId={postId}
            currentUser={currentUser}
          />
        ))}
      </div>
    </div>
  );
};

export default ReplyList;